import * as Yup from 'yup';

import momentLocalTimezone from 'src/utils/momentLocalTimezone';

export default Yup.object().shape({
  cededClientId: Yup.number().required('SCHEMA_ERRORS.SELECT_VALUE'),
  cedeDate: Yup.date()
    .required('SCHEMA_ERRORS.REQUIRED_FIELD')
    .min(
      momentLocalTimezone()
        .add(1, 'month')
        .startOf('month'),
      'SCHEMA_ERRORS.CEDE_DATE_MUST_BE_AT_LEAST_ONE_MONTH'
    )
});
